import { reducer } from './reducer';
import ClientSetupParams from '../../lib/interfaces/ClientSetupParams';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ClientSetupState {
  params?: ClientSetupParams
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface SetClientParamsAction {
  type: "SET_CLIENT_PARAMS";
  params: ClientSetupParams
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownOrderPadAction = SetClientParamsAction;

export const unloadedClientSetupState: ClientSetupState = { 
  params: undefined
};

export { reducer };